/**
 * Взято из lead-realtor-form /v1/get-form
 * question: offerType
 * @see question.answers
 * */
export var EOfferType;

(function (EOfferType) {
  EOfferType["Flat"] = "flat";
  EOfferType["Suburban"] = "suburban";
  EOfferType["Commercial"] = "commercial";
})(EOfferType || (EOfferType = {}));

export var offerTypeSelectorOptions = [{
  value: EOfferType.Flat,
  selectedLabel: 'Жилая',
  label: 'Жилая'
}, {
  value: EOfferType.Suburban,
  selectedLabel: 'Загородная',
  label: 'Загородная'
}, {
  value: EOfferType.Commercial,
  selectedLabel: 'Коммерческая',
  label: 'Коммерческая'
}];